<div class="financial-scorecard-costs-card">
  <div class="financial-scorecard-costs-card-header">
    <p 
      class="financial-scorecard-costs-card-title"
    >
      {{ kpiData().title | truncateWord:9}}
      @if(maxTitleLength > 9)
      {
        <a (click)="displayDrilldown2()">read more</a>
      }
    </p>
  </div>
  <div class="financial-scorecard-costs-card-statuses">
    @if(kpiData() && kpiData().achievedStatus) {
    <stc-apps-kpi-status-card
      [kpiStatus]="kpiData().achievedStatus!"
      [kpiType]="'achieved'"
    />
    } @if(kpiData() && kpiData().formula) {
    <stc-apps-kpi-status-card
      [kpiStatus]="kpiData().formula!"
      [kpiType]="'not-achieved'"
    />
    } @if(kpiData() && kpiData().actual) {
    <stc-apps-kpi-status-card
      [kpiStatus]="kpiData().actual!"
      [kpiType]="'actual'"
      [domainIndicator]="kpiData().unit"
    />
    }
  </div>
  @if(kpiData().details && kpiData().details?.length !== 0)
  {
    <p class="kpi-details" [class.short-text]="maxTextLength < 9">
      {{kpiData().details! | truncateWord:6}}
      @if(maxTextLength >= 6)
      {
        <a (click)="displayDrilldown()">read more</a>
      }
    </p>
  } @else {
    <p class="no-kpi-details">
      no description
    </p>
  }
  <div class="financial-scorecard-costs-card-cards">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="financial-scorecard-costs-card-cards-weight">
          <div class="weight-card">
            <p class="weight2">weight</p>
            <span>:</span>
            <p class="weight-val">{{ kpiData().weight }}%</p>
          </div>
          <div class="weight-card">
            <p class="weight2">unit</p>
            <span>:</span>
            <p 
              class="weight-val"
              (mouseenter)="overlayPanel3 ? overlayPanel3.show($event) : ''" 
              (mouseleave)="overlayPanel3 ? overlayPanel3.hide() : ''"
            >{{ kpiData().unit | truncateWord:2 }}</p>
            @if(kpiData().unit.split(" ").length > 2)
            {
              <p-overlayPanel #overlayPanel3 dismissable="true">
                <section class="unit-popover-section">{{kpiData().unit}}</section>
              </p-overlayPanel>
            }
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="financial-scorecard-costs-card-cards-weight">
          <div class="weight-card">
            <p class="weight2">baseline</p>
            <span>:</span>
            <p class="weight-val">
              @if (kpiData().baseline) {
              {{ kpiData().baseline }}
              @if (kpiData().unit === '%') { % } } @else { N/A }
            </p>
          </div>
          <div class="weight-card">
            <p class="weight2">target</p>
            <span>:</span>
            <p class="weight-val">
              {{ kpiData().target }}
              @if (kpiData().unit === '%') { % }
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="financial-scorecard-costs-card-cards-ceiling">
          <p>ceiling</p>
          <span>{{ kpiData().ceiling }}%</span>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="financial-scorecard-costs-card-cards-ceiling">
          <p>threshold</p>
          <span>{{ kpiData().threshold }}%</span>
        </div>
      </div>
    </div>
  </div>
</div>
@if(kpiData().details)
{
  <p-overlayPanel #overlayPanel dismissable="true">
    <section class="popover-section" [innerHTML]="kpiData().details! | newLine"></section>
  </p-overlayPanel>
}
@if(kpiData().title.length > 20)
{
  <p-overlayPanel #overlayPanel2 dismissable="true">
    <section class="popover-section">{{kpiData().title}}</section>
  </p-overlayPanel>
}